<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      isServerErrorShown: false,
      isConnectionErrorShown: false,
    }
  },
  created () {
    console.log(`build_date: ${process.env.BUILD_DATE}`)
    console.log(`git_hash: ${process.env.GIT_HASH}`)
    this.$request.on('error', err => {
      if (err.status === 500) {
        if (!this.isServerErrorShown) {
          this.isServerErrorShown = true
          this.$notify({
            title: 'API Server Error',
            message: 'APIサーバでエラーが発生しました',
            type: 'error',
            duration: 0,
            onClose: () => {
              this.isServerErrorShown = false
            },
          })
        }
      } else if (err.status === 401) {
        this.$router.push({name: 'Login'})
      } else if (!err.status) {
        if (!this.isConnectionErrorShown) {
          this.isConnectionErrorShown = true
          this.$notify({
            title: 'API Server Connection Error',
            message: 'APIサーバと接続できませんでした．\nしばらく時間をおいて再度お試しください',
            customClass: 'notify-api-error',
            type: 'error',
            duration: 0,
            onClose: () => {
              this.isConnectionErrorShown = false
            },
          })
        }
      }
    })
  },
}
</script>

<style>
body, html {
  margin: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue